import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastService, ToastType } from '../services/toast.service';

@Component({
  selector: 'app-toast-container',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="fixed top-4 right-4 z-[100] w-[92vw] max-w-sm space-y-3 pointer-events-none">
      @for (t of toast.toasts(); track t.id) {
        <div
          class="pointer-events-auto rounded-xl border shadow-xl backdrop-blur bg-white/95 dark:bg-slate-900/90 overflow-hidden"
          [ngClass]="{
            'border-emerald-200 dark:border-emerald-900': t.type === 'success',
            'border-red-200 dark:border-red-900': t.type === 'error',
            'border-slate-200 dark:border-slate-700': t.type === 'info'
          }"
        >
          <div class="p-4 flex items-start gap-3">
            <div class="mt-0.5">
              <span
                class="inline-flex h-9 w-9 items-center justify-center rounded-lg"
                [ngClass]="{
                  'bg-emerald-100 dark:bg-emerald-900/40': t.type === 'success',
                  'bg-red-100 dark:bg-red-900/40': t.type === 'error',
                  'bg-blue-100 dark:bg-blue-900/40': t.type === 'info'
                }"
              >
                <svg *ngIf="icon(t.type) === 'check'" class="h-5 w-5 text-emerald-700 dark:text-emerald-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                </svg>
                <svg *ngIf="icon(t.type) === 'x'" class="h-5 w-5 text-red-700 dark:text-red-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                </svg>
                <svg *ngIf="icon(t.type) === 'info'" class="h-5 w-5 text-blue-700 dark:text-blue-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M12 18a6 6 0 100-12 6 6 0 000 12z"></path>
                </svg>
              </span>
            </div>

            <div class="min-w-0 flex-1">
              <p class="text-sm font-semibold text-slate-900 dark:text-white truncate">{{ t.title || label(t.type) }}</p>
              <p class="text-sm text-slate-600 dark:text-slate-300 mt-0.5 leading-snug break-words">{{ t.message }}</p>
              <div class="mt-3 h-1 rounded bg-slate-200/70 dark:bg-slate-700 overflow-hidden">
                <div
                  class="h-full rounded"
                  [ngClass]="{
                    'bg-emerald-500': t.type === 'success',
                    'bg-red-500': t.type === 'error',
                    'bg-blue-500': t.type === 'info'
                  }"
                ></div>
              </div>
            </div>

            <button
              type="button"
              class="shrink-0 text-slate-400 hover:text-slate-600 dark:text-slate-500 dark:hover:text-slate-300"
              (click)="toast.dismiss(t.id)"
              aria-label="Dismiss notification"
            >
              ✕
            </button>
          </div>
        </div>
      }
    </div>
  `,
})
export class ToastContainerComponent {
  toast = inject(ToastService);

  icon(type: ToastType): 'check' | 'x' | 'info' {
    if (type === 'success') return 'check';
    if (type === 'error') return 'x';
    return 'info';
  }

  label(type: ToastType): string {
    if (type === 'success') return 'Success';
    if (type === 'error') return 'Error';
    return 'Info';
  }
}

